<template>
  <!-- <v-parallax src=""> -->
  <v-row>
    <v-col class="pa-6"
      :style="[
      {'background-image': `url('${require('@/assets/fondo-loginstrategio.jpg')}')`},
      {'background-repeat': 'no-repeat'},
      {'background-size': 'cover'}
      ]"
    >
      <v-container id="codigo-usuario" fluid>
        <v-row class="py-md-4 ma-lg-4" align-content="center">
          <v-col >
            <v-img width="253px" height="auto" :src="require('@/assets/logo-vida-software.png')"></v-img> 
          </v-col>
        </v-row>
        <v-row class="pa-md-8 ma-md-8"></v-row>
        <v-row class="pt--md-16 ma-5">
          <v-col class="py-3">
            <div id="brand-message-title" class="text-sm-left">
              {{brandMessage.title}}
            </div>
            <div id="brand-message-subtitle">
              {{brandMessage.subtitle}}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    
    <v-col
    :style="[
      {'background-color': `#FBFBFB`}      
      ]"
    >
      <v-container id="codigo-usuario" fluid>
        <v-col>
          <v-row class="py-md-4 ma-lg-3" align-content="center">
            <v-col>
              <v-img width="235px" height="auto" :src="require('@/assets/logo-strategio.png')"></v-img>
            </v-col>
          </v-row>
          <v-row align-content="center">
            <v-col>
              <v-form @submit="logIn($event)"> 
                <v-card class="pa-lg-16 mx-lg-16" elevation="0" color="#FBFBFB" style="padding: 6px!important;">
                  <v-row class="hidden-xs-only">
                    <v-col cols="8" align-self="center" >
                      <v-card-text class="text-h3" style="color:#25235F;-webkit-text-stroke: 0.8px; height: auto; font-size: 11vw; font-weight: bold;">
                     Restaura tu contraseña
                      </v-card-text>
                    </v-col>
                    <v-col align-self="center" cols="3" offset-lg="1">
                      <v-img  width="83.83px" height="auto" :src="require('@/assets/icono-strategio.png')"></v-img>
                    </v-col>
                   </v-row>
                        
                   <v-card-text>
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:21px;font-weight:700"> Usuario
                      </v-card-text>                       
                      <v-text-field class="pa-xs-0 txtUser"
                        id="txtUser"
                        name="txtUser"
                        label="Escribe tu usuario"
                        prepend-inner-icon="person_outline"
                        outlined
                        background-color="#FFFFFF"
                        style="margin-bottom: -20px;"
                      ></v-text-field>                          
                    </div>
        
                    <div class="strategio-login-error-message">
                      {{errorMessage}}
                    </div>
                    <div>
                      <a v-on:click="restaurar_cont">Olvidaste tu contraseña?</a>
                    </div>
                    <div>
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:18px;"
                        block large rounded depressed
                        class="mx-0"
                        type="submit"
                        :loading="isLoading"
                        @click.native="loader = 'loading'"
                        :disabled="isLoading"
                      >
                        Enviar  
                      </v-btn>
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:18px;"
                        block large rounded depressed
                        class="mx-0"
                        type="submit"
                        :loading="isLoading"
                        @click.native="loader = 'loading'"
                        :disabled="isLoading"
                      >
                        Volver  
                      </v-btn>
                    </div>
                  
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
          <v-row class="pa-md-8 ma-md-8"></v-row>
          <v-row class="pa-md-8 ma-md-8"></v-row>
        </v-col>
      </v-container>

      <v-footer
        class="px-4 mb-2 text-right"
        color="transparent"
        style="font-size:10px;color:black;"
      >
        <v-col>
          © TODOS LOS DERECHOS RESERVADOS - VIDA SOFTWARE
        </v-col>
      </v-footer>
    </v-col>
  </v-row>

</template>

<script>
import auth from '../utils/auth'
import storageCleaner from '../utils/storageCleaner'

export default {
  name: 'codigo-usuario',
  data () {
    delete localStorage.token
    delete localStorage.user
    storageCleaner.cleanStorage()
    return {
      msg: 'Welcome to Your Vue.js App',
      hidePassword: true,
      errorMessage: '',
      isLoading: false,
      brandMessage: {
        title: 'Y tú ¿Cuánto vendiste ayer?',
        subtitle: 'Analiza lo mejor. Todo es realidad con nosotros'
      }
    }
  },
  methods: {
    logIn (e) {
      e.preventDefault()
      this.errorMessage = ''
      this.isLoading = true

      const user = document.getElementById('txtUser').value
      const password = document.getElementById('txtPassword').value
      auth.login({
        context: this,
        creds: {user, password},
        onSuccess: (response) => {
          this.isLoading = false
          console.log(response.data.user)
          if (response.data.user.forceChangePassword === 1) {
            response.data.status = '1'
            response.data.message = 'OK'
            this.$router.push({ name: 'UserAccount', params: { showStrategioAppBar: false } })
          } else {
            if (response.data.user.userType === 'SUPERVISOR') {
              this.$router.push('/supervise/dashboard')
            } else {
              // this.$router.push('/0')
              this.$router.push({
                name: 'MainPage',
                params: { folderID: '0', firstTimeMenu: true }
              })
            }
          }
        },
        onError: (error) => {
          this.isLoading = false
          let errMessage = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            errMessage = error.response.data.message
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            errMessage = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            errMessage = `Error desconocido: ${error.errorMessage}`
          }
          this.errorMessage = errMessage
          // console.log(error.config)
        }
      })
      return false
    }
  }
}
</script>
<style>
.strategio-login-error-message {
  text-align: center;
  color: #F44336;
}
._poweredBy {
  margin-top: 16px;
  text-align: right;
  font-weight: 600;
}
#brand-message-title {
  font-size: 4vw;
  font-weight: bold;
  /* text-align: right; */
  color: #55CCFF;
}

#brand-message-subtitle {
  font-size: 2vh;
  font-weight: normal;
  text-align: start;
  color: white;
}

#txtUser {
  font-family: 'Open Sans'; 
  font-weight: 700;
}

/* Correción para el texto en outline que se va mucho a la izquierda */
.txtUser .v-label.theme--light.error--text {
left: 0 !important;
}
.txtUser .v-label.v-label--active.theme--light {
left: -27px !important;
}

</style>



// WEBPACK FOOTER //
// src/routes/codigo-usuario.vue